import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, RouterStateSnapshot } from "@angular/router";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";

import { UiService } from "@services/ui.service";
import { HolidayGroupsService } from "@services/holiday-groups.service";
import { HolidayGroup } from "@classes/holiday/holiday-group";


@Injectable()
export class HolidayGroupsResolver  {
    constructor(
        private holidayGroupsSrv: HolidayGroupsService,
        private uiSrv: UiService
    ) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<HolidayGroup[]> {
        this.uiSrv.routeLoadingStateChanged.next(true);
        return this.holidayGroupsSrv.get()
        .pipe(
            tap(() => {
                this.uiSrv.routeLoadingStateChanged.next(false);
            })
        );
    }
}
